import React from 'react';
import AutoLoanAccountsView from 'partial/OfferManager/modules/AutoRefinanceMarketplaceModule/components/AutoLoanAccountsView';
import AutoRefinanceMarketplaceOffersView from 'partial/OfferManager/modules/AutoRefinanceMarketplaceModule/components/AutoRefinanceMarketplaceOffersView';

const AutoRefinanceOcfModuleView = props => {
  if (props.seeAutoRefinanceLoans || props.refinanceOffers) {
    return (
      <AutoRefinanceMarketplaceOffersView {...props} hideDisclaimer={true} />
    );
  } else if (props.showAutoLoanList) {
    return (
      <AutoLoanAccountsView
        {...props}
        className={'margT40 m-margT0'}
        title={'Let’s see how much you can save on your auto loans'}
        subTitle={
          'Choose an option below to save cash or find better terms for your auto loans.'
        }
        ctaCopy={'Explore Options'}
      />
    );
  }
};

export default AutoRefinanceOcfModuleView;
